import * as React from 'react';

import type { EnrollType } from 'bundles/internal-enterprise/types/Program';
import { enroll } from 'bundles/internal-enterprise/utils/apiUtils';
import Modal from 'bundles/internal-ui/components/modal/Modal';

type Props = {
  onClosed: () => void;
  enrollType: EnrollType;
  programId: string;
  item: { id: string; name: string };
  userId: string;
};

type State = {
  error?: string;
};

class CurriculumEnrollmentWarningModal extends React.Component<Props, State> {
  state = {
    error: undefined,
  };

  handleEnrollment = () => {
    const { enrollType, programId, item, userId } = this.props;
    enroll(enrollType, programId, item.id, userId)
      .then(() => {
        window.location.reload();
      })
      .fail((e) => {
        this.setState({ error: JSON.stringify(e.responseJSON, null, 2) });
      });
  };

  render() {
    const { onClosed, enrollType, item } = this.props;
    const itemType = enrollType === 'enrollInCourse' ? 'course' : 'specialization';
    return (
      <Modal
        title={`${itemType.charAt(0).toUpperCase() + itemType.slice(1)} Enrollment`}
        onRequestClose={onClosed}
        open={true}
        actions={[
          {
            text: 'Enroll Learner',
            onClick: this.handleEnrollment,
            style: 'primary',
          },
          {
            text: 'Close',
            onClick: onClosed,
            style: 'danger',
          },
        ]}
      >
        <div>
          Are you sure you want enroll this learner in the {itemType} {item.name}?
          {this.state.error && (
            <div>
              <hr />
              Error:
              <pre style={{ whiteSpace: 'pre-wrap' }}>{this.state.error}</pre>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default CurriculumEnrollmentWarningModal;
